import type { SVGProps } from 'react';
const SvgRecycleBin2StreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Recycle Bin 2 Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M1.321 4.625H17.18M3.304 4.625h11.892v11.893a1.32 1.32 0 0 1-1.321 1.321h-9.25a1.32 1.32 0 0 1-1.321-1.321zM5.946 4.625v-.66a3.304 3.304 0 1 1 6.608 0v.66M7.268 8.591v5.288M11.232 8.591v5.288" />
    </g>
  </svg>
);
export default SvgRecycleBin2StreamlineCore;
